import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  BLOCKS,
  Document as RichTextDocument,
} from "@contentful/rich-text-types";
import { Button } from "@components/shared/core/Button";
import { Link } from "@components/shared/core/Link";
import { DEFAULT_404 } from "./DEFAULT_404";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "@services/i18n";
import { OBELIX_404_KEYS } from "@utils/obelixKeys";

export function NotFound() {
  const item = DEFAULT_404;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          {t(OBELIX_404_KEYS.title.obelixKey, OBELIX_404_KEYS.title.label)}
        </title>
      </Helmet>
      <section className="aspect-video w-full dsk:min-h-full min-h-screen flex flex-col justify-center items-center relative gap-9">
        <img
          src={item.background.url}
          alt=""
          className="absolute inset-0 w-full h-full object-cover brightness-60"
        />
        <div className="z-10 mt-auto">
          <h1 className="text-heading-1 whitespace-pre-wrap text-center text-brand-cream">
            {item.title ??
              t(OBELIX_404_KEYS.title.obelixKey, OBELIX_404_KEYS.title.label)}
          </h1>
        </div>
        <div className="z-10">
          {item.body?.json != null ? (
            documentToReactComponents(item.body.json as RichTextDocument, {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => (
                  <p className="text-body-regular">{children}</p>
                ),
              },
            })
          ) : (
            <p className="text-body-regular text-brand-cream">
              {t(OBELIX_404_KEYS.body.obelixKey, OBELIX_404_KEYS.body.label)}
            </p>
          )}
        </div>
        <div className="z-10 mt-auto mb-8">
          <Button asChild variant="light-on-blur">
            <Link href="/">
              {item.ctaText ??
                t(OBELIX_404_KEYS.cta.obelixKey, OBELIX_404_KEYS.cta.label)}
            </Link>
          </Button>
        </div>
      </section>
    </>
  );
}
